import { useMutation } from "react-query";
import http from "infra/http";
import { EquipamentoForm, EquipamentoArquivo } from "../typings";
import { createFormData } from "infra/helpers/createFormData";
import { AxiosError } from "axios";

function useSaveEquipamento() {
  return useMutation<{ id: string }, AxiosError, EquipamentoForm>(
    async (form: EquipamentoForm) => {
      const formData = createFormData(
        form.arquivos || [],
        form,
        "files",
        "arquivos"
      );

      const arquivosAntigosIds = form.arquivos
        ?.filter((file) => !(file instanceof File))
        .map((file) => (file as EquipamentoArquivo).id);

      formData.append("oldFilesIds", JSON.stringify(arquivosAntigosIds));

      if (form.id) {
        const { data } = await http.put<{ id: string }>(
          `/v1/equipamento/${form.id}`,
          formData
        );

        return data;
      }

      const { data } = await http.post(`/v1/equipamento`, formData);

      return data;
    },
    { retry: false }
  );
}

export default useSaveEquipamento;
